import React, { useState, useEffect } from "react";
import { errorHandler } from "../ErrorHandler";
import PingDialog from "../modals/PingDialog";

const initialForm = {
  userName: "",
  password: "",
};

const FormLogin = ({
  loginCall,
  pingStatusOk,
  setDialogPingVisible,
  dialogPingVisible,
  newUserPassword,
}) => {
  const [form, setForm] = useState(initialForm);
  const [svcConnected, setSvcConnected] = useState(false);

  useEffect(() => {
    if (newUserPassword.password !== "") {
      setForm({
        ...form,
        password: newUserPassword.password,
        userName: newUserPassword.user,
      });
    }
  }, [newUserPassword]);

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === "userName") {
      value = e.target.value.toUpperCase();
    }

    setForm({
      ...form,
      [e.target.name]: value,
    });
  };

  //Mensaje de error si faltan datos en el Login
  const handleSubmit = () => {
    if (!form.userName || !form.password) {
      errorHandler("Incomplete data");
      return;
    }
    loginCall(form);
    setForm(initialForm);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  //This useEffect runs when svcConnected change and it's true, not letting the user to continue
  useEffect(() => {
    if (pingStatusOk) {
      setSvcConnected(true);
    } else {
      setSvcConnected(false);
    }
  }, [pingStatusOk]);

  return (
    <section className="vh-100">
      <div
        className="vh-100"
        style={{
          backgroundImage: "url('../images/LoginDGS.png')",
          backgroundRepeat: "no-repeat, repeat",
          backgroundSize: "85%",
        }}
        onKeyDown={handleKeyPress}
        tabIndex="0"
      >
        <div
          className="row d-flex align-items-center h-100"
          style={{ margin: 0 }}
        >
          <div className="col-md-8 col-lg-7 col-xl-7"></div>
          <div className="col-md-7 col-lg-5 col-xl-3 offset-xl-1">
            <div
              className="card"
              style={{
                backgroundColor: "rgba(242, 242, 242, 0.3)",
                boxShadow: "7px 7px 7px #00334d",
              }}
            >
              <div className="card-body text-center">
                <div>
                  <img
                    alt=""
                    src="../images/iconWhiteRacingClient1.png"
                    className="mb-3"
                    style={{ height: "100px", width: "130px" }}
                  />
                </div>

                <div
                  className="input-group mb-4"
                  style={{ backgroundColor: "transparent" }}
                >
                  <i
                    className="feather icon-user auth-icon mt-2 mr-2"
                    style={{ fontSize: "24px", color: "#ffffff" }}
                  ></i>
                  <input
                    type="text"
                    placeholder="Username"
                    id="userName"
                    name="userName"
                    onChange={handleChange}
                    value={form.userName}
                    className="form-control form-control-lg"
                  />
                </div>

                <div
                  className="input-group mb-4"
                  style={{ backgroundColor: "transparent" }}
                >
                  <i
                    className="feather icon-unlock auth-icon mt-2 mr-2"
                    style={{ fontSize: "24px", color: "#ffffff" }}
                  ></i>
                  <input
                    type="Password"
                    placeholder="Password"
                    id="password"
                    name="password"
                    onChange={handleChange}
                    value={form.password}
                    className="form-control form-control-lg"
                  />
                </div>
                <div style={{ textAlign: "center" }}>
                  <button
                    type="submit"
                    style={{ margin: "0px" }}
                    className="btn btn-light btn-lg"
                    onClick={() => handleSubmit()}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PingDialog
        visible={dialogPingVisible}
        onHide={() => setDialogPingVisible(false)}
        pong={svcConnected}
        setDialogPingVisible={setDialogPingVisible}
      />
    </section>
  );
};

export default FormLogin;
